import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import * as Yup from "yup";
import {
  Field,
  FieldArray,
  Form,
  Formik,
  useFormik,
  useFormikContext,
} from "formik";
import { allCountries } from "../RegistrationDatas";
import CustomFileInput from "../../../Components/InputCompo/CustomFileInput";
import { m } from "framer-motion";
import { fadeIn } from "../../../Functions/GlobalAnimations";
import { enqueueSnackbar } from "notistack";
import {
  editRegistration,
  initialLoading,
  initialRegistration,
  initialSubRegistration,
} from "../../../Store/auth/register";
import MultipleSelect from "../../../Components/SelectionComp/MultipleSelect";
import Loading from "../../../Components/Loader/Loading";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddCommentIcon from "@mui/icons-material/AddComment";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ModalComp from "../../../Components/ModalComp";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
const RegistrationFirst = ({ setSubTabs }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, settableData] = useState();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const reg_key = localStorage.getItem("RegKey");
  const gsn_no = localStorage.getItem("gsn_no");
  const DBName = localStorage.getItem("Db_name");
  const queryClient = useQueryClient();
  const { isLoading: fieldLoading, data: questions } = useQuery({
    queryKey: ["Questions", reg_key],
    queryFn: () =>
      initialLoading(reg_key && DBName ? DBName : "Pending DB", reg_key),
    cacheTime: 1000 * 60 * 5,
    staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
  });

  // validations for fields
  const notDisplayEle =
    DBName === "Raw Data DB"
      ? []
      : [
          "IRQ-00012",
          "IRQ-00013",
          "IRQ-00014",
          "IRQ-00015",
          "IRQ-00016",
          "IRQ-00017",
          "IRQ-00018",
          "IRQ-00019",
        ];

  const modelSchema = Yup.object({
    normalFields: Yup.object(
      questions?.documents?.reduce((schema, fields) => {
        let fieldValidation = Yup.string();
        // if (fields.type.toLowerCase() !== "section") {

        // Check if the field has a dependent question with a condition
        if (fields.depend_question && fields.condition) {
          fieldValidation = fieldValidation.test(
            "dependent-condition",
            `${fields.question} is required when the condition is met`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];
              // Evaluate the condition using evaluateCondition function
              const isConditionMet = evaluateCondition(
                dependentValue,
                fields.condition,
                fields.value
              );
              // If condition is true, apply required validation, otherwise allow optional
              return isConditionMet ? !!value : true;
            }
          );
        }
        if (fields.validation.toLowerCase() === "email") {
          fieldValidation = fieldValidation.test(
            "match-dependent",
            ` Re-enter your organisation's primary email address to confirm it's correct. This must match the email entered in the previous question  to ensure successful registration`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];
              if (dependentValue) {
                return value === dependentValue;
              }
              return true;
            }
          );
        } else if (fields.type.toLowerCase() === "password") {
          fieldValidation = fieldValidation.test(
            "match-dependent",
            `Re-enter your password to confirm it matches the one you entered  in the previous question. This ensures your password is set correctly`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];
              if (dependentValue) {
                return value === dependentValue;
              }
              return true;
            }
          );
        }

        // Apply different validation rules based on the field's validation type
        if (
          fields.validation.toLowerCase() === "email" &&
          !fields.depend_question
        ) {
          fieldValidation = fieldValidation.matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Invalid email address"
          );
        } else if (fields.validation.toLowerCase() === "pan") {
          fieldValidation = fieldValidation.matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Invalid PAN Number. It should be in the format: ABCDE1234F."
          );
        } else if (fields.validation.toLowerCase() === "pincode") {
          fieldValidation = fieldValidation.matches(
            /^\d{4}$|^\d{6}$/,
            "PIN code must be exactly 6 digits"
          );
        } else if (fields.validation.toLowerCase() === "areacode") {
          fieldValidation = fieldValidation.matches(
            /^(123|456|789)$/,
            "Incorrect area code"
          );
        } else if (fields.type.toLowerCase() === "multiselect dropdown") {
          fieldValidation = Yup.array();
        } else if (fields.validation.toLowerCase() === "website") {
          fieldValidation = fieldValidation.url("Please enter a valid URL");
        } else if (fields.validation.toLowerCase() === "mobile") {
          fieldValidation = fieldValidation.matches(
            /^(?:[0-9]{10}|[0-9]{7})$/,
            "Invalid contact number"
          );
        } else if (fields.type.toLowerCase() === "attach") {
          fieldValidation = Yup.object();
        } else if (fields.validation.toLowerCase() === "darpan") {
          fieldValidation = fieldValidation.test(
            "is-valid-darpan",
            " Darpan Id should be in the format: XX/1234/1234567",
            (value) =>
              value?.toUpperCase() === "NA" ||
              /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
          );
        } else if (
          fields.validation.toLowerCase() === "password" &&
          !fields.depend_question
        ) {
          fieldValidation = fieldValidation.matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/,
            "Password must be at least 8 characters long, and contain at least one uppercase letter, one lowercase letter, one number, and one special character."
          );
        }

        // Mark field as required based on the `mandatory` flag if condition is not applicable
        if (
          !fields.depend_question &&
          fields.type.toLowerCase() !== "section" &&
          fields?.mandatory === 1
        ) {
          fieldValidation = fieldValidation.required(
            `${fields?.question} is required`
          );
        }

        // Assign validation schema for the field
        schema[fields?.question_no] = fieldValidation;
        return schema;
        // }
      }, {})
    ),
    ...questions?.documents?.reduce((sectionSchemas, fields) => {
      if (fields.type.toLowerCase() === "section") {
        sectionSchemas[fields.template] = Yup.array().of(
          Yup.object(
            fields.sub_questions.reduce((subSchema, subField) => {
              let subFieldValidation = Yup.string();

              if (subField.depend_question && subField.condition) {
                subFieldValidation = subFieldValidation.test(
                  "dependent-condition",
                  `${subField.question} is required when the condition is met`,
                  function (value) {
                    const { parent } = this;
                    const dependentValue = parent[subField.depend_question];
                    // Evaluate the condition using evaluateCondition function
                    const isConditionMet = evaluateCondition(
                      dependentValue,
                      subField.condition,
                      subField.value
                    );

                    // If condition is true, apply required validation, otherwise allow optional
                    return isConditionMet ? !!value : true;
                  }
                );
              }

              // Similar logic for sub-questions (optional)
              if (subField?.validation?.toLowerCase() === "email") {
                subFieldValidation = subFieldValidation.matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email address"
                );
              }
              if (subField?.validation?.toLowerCase() === "areacode") {
                subFieldValidation = subFieldValidation.matches(
                  /^(123|456|789)$/,
                  "Invalid area code"
                );
              } else if (subField.validation?.toLowerCase() === "pan") {
                subFieldValidation = subFieldValidation.matches(
                  /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                  "Invalid PAN Number. It should be in the format: ABCDE1234F."
                );
              } else if (subField?.validation?.toLowerCase() === "pincode") {
                subFieldValidation = subFieldValidation.matches(
                  /^\d{4}$|^\d{6}$/,
                  "PIN code must be exactly 6 digits"
                );
              } else if (subField.question_no === "SQ-00004") {
                subFieldValidation = subFieldValidation
                  .test(
                    "require-if-mobile-or-telephone",
                    `${subField.question} is required when SQ-00001 is mobile or telephone`,
                    function (value) {
                      const { parent } = this;
                      const type = parent["SQ-00001"];
                      if (["Mobile", "Telephone"].includes(type)) {
                        return !!value;
                      }
                      return true;
                    }
                  )
                  .test("validate-based-on-type", function (value) {
                    const { parent, path, createError } = this;
                    const type = parent["SQ-00001"];
                    const areaCode = parent["SQ-00003"] || "";
                    if (type === "Mobile") {
                      const isValidMobile = /^[0-9]{10}$/.test(value);
                      return (
                        isValidMobile ||
                        createError({
                          path,
                          message: "Mobile number must be exactly 10 digits",
                        })
                      );
                    }
                    if (type === "Telephone") {
                      // Remove leading 0 from area code
                      const areaCodeNoZero = areaCode.replace(/^0+/, "");
                      const combined = `${areaCodeNoZero}${value}`;
                      if (!/^[0-9]+$/.test(combined)) {
                        return createError({
                          path,
                          message:
                            "Area code and telephone number must be numeric",
                        });
                      }
                      if (combined.length !== 10) {
                        return createError({
                          path,
                          message:
                            "Area code (without the starting 0) + telephone number must be exactly 10 digits",
                        });
                      }
                      return true;
                    }
                    return true;
                  });
              }

              if (subField.mandatory === 1) {
                subFieldValidation = subFieldValidation.required(
                  `${subField.question} is required`
                );
              }

              subSchema[subField.question_no] = subFieldValidation;
              return subSchema;
            }, {})
          )
        );
      }
      return sectionSchemas;
    }, {}),
  });

  // formik for submission fields

  const handleCreateSuccess = () => {
    setTimeout(() => {
      if (DBName === "Raw Data DB") {
        localStorage.setItem("Db_name", "Pending DB");
      }
      navigate("/npo-login", { state: "fromInitial" });
    }, 1000);
    enqueueSnackbar(
      "Check your email and log in to complete your registration",
      { variant: "success" }
    );
  };

  const handleCreateError = (error) => {
    console.log(error?.response);
    if (error?.response?.status >= 450) {
      enqueueSnackbar(
        error?.response?.data?.status_message ||
          error?.response?.data?._error_message,
        {
          variant: "error",
        }
      );
    } else {
      enqueueSnackbar(
        error?.response?.data?.message ||
          error?.response?.data?.message?._error_message ||
          error?.message,
        {
          variant: "error",
        }
      );
    }
  };

  const createFarmerMutationOptions = {
    onSuccess: handleCreateSuccess,
    onError: handleCreateError,
  };

  const {
    mutate: submitInitialReg,
    data: regFinalData,
    isPending: mainRegistration,
  } = useMutation({
    mutationFn: initialRegistration,
    ...createFarmerMutationOptions,
  });

  useEffect(() => {
    if (regFinalData?.application_no) {
      localStorage.setItem("RegKey", regFinalData?.application_no);
      submitTable(regFinalData?.application_no);
    }
  }, [regFinalData?.application_no]);

  const attachFile = (e, setFieldValue) => {
    if (!e.target.files || e.target.files.length === 0) {
      setFieldValue(e.target.name, "");
      return; // Prevent further execution if no file is selected
    }
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setFieldValue(name, {
          attach_file: base64String,
          file_name: file.name,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const evaluateCondition = (value1, condition, value2) => {
    switch (condition) {
      case "==":
        return value1 == value2; // Using loose equality as per original suggestion
      case "===":
        return value1 === value2;
      case "!==":
        return value1 !== value2;
      case ">":
        return value1 > value2;
      case "<":
        return value1 < value2;
      case ">=":
        return value1 >= value2;
      case "<=":
        return value1 <= value2;
      default:
        return false;
    }
  };

  const createInitialValues = () => {
    if (questions?.docs_answers?.length > 0) {
      return questions.docs_answers.reduce((values, field) => {
        if (field.type.toLowerCase() === "section") {
          // Initialize section with template name as an array of objects
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach((Field) => {
                if (!tempData[index]) tempData[index] = {}; // Ensure initialization

                if (Field?.type?.toLowerCase() === "multiselect dropdown") {
                  tempData[index][Field?.question_no] =
                    Field?.answer?.split(",") || [];
                } else if (Field?.type.toLowerCase() === "attach") {
                  tempData[index][Field?.question_no] = {
                    file_name: Field?.upload_document,
                  };
                } else {
                  tempData[index][Field?.question_no] = Field?.answer || ""; // Ensure default empty value
                }
              });
            });
            values[field.template] = values[field.template] || tempData; // Ensure array initialization
          } else {
            values[field.template] = values[field.template] || [{}]; // Ensure array initialization
            values[field.template].forEach((row) => {
              field?.sub_questions?.forEach((subField) => {
                row[subField?.question_no] =
                  subField?.question === "Country Code" ? "+91 - India" : "";
              });
            });
          }
        } else {
          // Normal fields, assign to `normalFields`
          values.normalFields = values.normalFields || {};
          if (field?.question_no) {
            if (field.type.toLowerCase() === "multiselect dropdown") {
              values.normalFields[field.question_no] =
                field?.answer?.split(",") || [];
            } else if (field?.type.toLowerCase() === "attach") {
              values.normalFields[field.question_no] = {
                file_name: field?.upload_document,
              };
            } else {
              values.normalFields[field.question_no] = field?.answer || ""; // Ensure default empty value
            }
          }
        }
        return values;
      }, {});
    } else {
      return questions?.documents?.reduce((values, field) => {
        values.normalFields = values.normalFields || {};
        values.normalFields[field?.question_no] = "";

        if (field.type.toLowerCase() === "section") {
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach((Field) => {
                if (!tempData[index]) tempData[index] = {}; // Ensure initialization

                tempData[index][Field?.question_no] = Field?.answer || ""; // Ensure default empty value
              });
            });
            values[field.template] = values[field.template] || tempData; // Ensure array initialization
          } else {
            values[field.template] = values[field.template] || [{}]; // Ensure array initialization
            values[field.template].forEach((row) => {
              field?.sub_questions?.forEach((subField) => {
                row[subField?.question_no] =
                  subField?.question === "Country Code" ? "+91 - India" : "";
              });
            });
          }
        }
        return values;
      }, {});
    }
  };

  const createNewRow = (sub_questions) => {
    let newRow = {};
    sub_questions.forEach((subField) => {
      newRow[subField.question_no] =
        subField.question === "Country Code" ? "+91 - India" : "";
    });
    return newRow;
  };

  const toggleAllRows = (e, values, template) => {
    const isChecked = e.target.checked;
    setSelectedRows({
      [template]: isChecked ? values?.[template]?.map((_, index) => index) : [],
    });
  };

  const toggleRowSelection = (rowIndex, template) => {
    setSelectedRows((prevSelected) => {
      // Get the current selected rows for the template or set it to an empty array if it doesn't exist
      const currentSelectedRows = prevSelected?.[template] || [];

      // Check if the row is already selected
      const isRowSelected = currentSelectedRows.includes(rowIndex);

      // Create the updated selected rows for the template
      const updatedSelectedRows = isRowSelected
        ? currentSelectedRows.filter((index) => index !== rowIndex) // Deselect row
        : [...currentSelectedRows, rowIndex]; // Select row

      // Return the new state with the updated template
      return {
        ...prevSelected,
        [template]: updatedSelectedRows,
      };
    });
  };

  console.log("selectedRows>>>", selectedRows);

  // const deleteSelectedRows = (remove) => {
  //     selectedRows.sort((a, b) => b - a); // Sort in descending order to avoid index shifting
  //     selectedRows.forEach((index) => remove(index));
  //     setSelectedRows([]); // Clear selection after deletion
  // };
  const deleteSelectedRows = (remove, template) => {
    selectedRows?.[template].sort((a, b) => b - a); // Sort in descending order to avoid index shifting
    selectedRows?.[template].forEach((index) => remove(index));
    setSelectedRows([]); // Clear selection after deletion
  };

  const DisplayFormikValues = () => {
    const { values, errors, setFieldValue } = useFormikContext();
    const calculateValues = useCallback(
      debounce(() => {
        const UserInputs = values?.["Telephone Number"];
        if (UserInputs?.length > 0) {
          if (!UserInputs) return;
          let item1 = "";
          UserInputs.forEach((value, index) => {
            item1 = value?.["SQ-00001"];
            if (value?.["SQ-00001"] === "Mobile") {
              setFieldValue(`Telephone Number.${index}.SQ-00003`, "");
            }
          });
        }
      }, 300),
      [values, setFieldValue]
    );
    useEffect(() => {
      calculateValues();
      // Cleanup to cancel debounce on unmount or re-render
      return () => calculateValues.cancel();
    }, [values?.["Telephone Number"], calculateValues]);

    return null; // You can return JSX or null if you just want to log the values
  };

  const multiSelectedValues = (name, question_no, value, setFieldValue) => {
    setFieldValue(name, value);
  };

  const SubmitData = (values) => {
    if (mainRegistration) return;
    localStorage.removeItem("RegKey");

    const sectionTablesWithData = questions?.documents?.filter(
      (doc) =>
        doc?.type?.toLowerCase() === "section" &&
        Array.isArray(values?.[doc.template]) &&
        values[doc.template].length > 0
    );

    if (sectionTablesWithData.length === 0) {
      enqueueSnackbar("Please add at least one row before submitting.", {
        variant: "warning",
      });
      return;
    }

    // Store section table data (you can combine them all or use the first one as needed)
    sectionTablesWithData.forEach((doc) => {
      settableData({ [doc.template]: values[doc.template] });
    });

    const tempData = values["normalFields"];

    const FinalData = questions?.documents?.map((field) => {
      const value = tempData?.[field.question_no];
      const type = field.type?.toLowerCase();

      if (type === "attach") {
        return {
          question_no: field.question_no,
          attach_file: value?.attach_file,
          file_name: value?.file_name,
        };
      }

      if (type === "number") {
        return {
          question_no: field.question_no,
          answer: `${value}`,
        };
      }

      if (type === "checkbox") {
        return {
          question_no: field.question_no,
          answer: value ? "Y" : "N",
        };
      }

      if (type === "multiselect dropdown" && Array.isArray(value)) {
        return {
          question_no: field.question_no,
          answer: value.join(", "),
        };
      }

      return {
        question_no: field.question_no,
        answer: value,
      };
    });
    let structuredData = "";
    if (DBName === "Raw Data DB") {
      structuredData = {
        args: {
          name: "",
          db_name: DBName || "Pending DB",
          initial_registration_answers: FinalData,
          raw_db_name: reg_key,
        },
      };
    } else {
      structuredData = {
        args: {
          name: reg_key || "",
          db_name: DBName || "Pending DB",
          initial_registration_answers: FinalData,
        },
      };
    }

    submitInitialReg(structuredData);
  };

  const submitTable = async (reg_name) => {
    if (reg_name) {
      try {
        const sections = questions?.documents?.filter(
          (ele) => ele.type.toLowerCase() === "section"
        );
        sections.map((ele) => {
          let passedValues = {
            args: {
              reg_name: reg_name,
              main_question_no: ele?.question_no,
              question_answers: [],
            },
          };
          if (ele?.template && tableData?.[ele?.template]) {
            tableData?.[ele?.template].forEach((ele, index) => {
              let tempQuestion_answers = [];

              const keys = Object.keys(ele);
              keys.forEach((key) => {
                tempQuestion_answers.push({
                  question_no: key,
                  answer: ele[key],
                });
              });

              passedValues.args.question_answers[index] = tempQuestion_answers;
            });

            if (passedValues.args.question_answers.length > 0) {
              submitSubReg(passedValues);
            }
          }
        });
        // Using forEach instead of map since we're not using the return value of map
      } catch (error) {}
    }
  };
  const { mutate: submitSubReg, isPending: subLoading } = useMutation({
    mutationFn: initialSubRegistration,
    ...createFarmerMutationOptions,
  });

  // Edit datas

  const OpenModal = (
    name,
    data,
    values,
    type,
    template,
    index,
    sub_question_num,
    subQuestion
  ) => {
    setIsModalOpen({
      [name]: true,
      data,
      values,
      type: type,
      index: index,
      template: template,
      sub_question_num: sub_question_num,
      subQuestion,
    });
  };

  const CloseModal = () => {
    if (!editLoading) {
      setIsModalOpen("");
    }
  };

  const updateValues = async (values) => {
    try {
      const currentDate = await new Date();
      let structuredData = "";
      if (isModalOpen?.type?.toLowerCase() === "section") {
        const PreviousData =
          Array.isArray(
            questions?.docs_answers?.find(
              (doc) => doc?.template === isModalOpen?.template
            )?.answer
          ) &&
          questions?.docs_answers
            ?.find((doc) => doc?.template === isModalOpen?.template)
            ?.answer?.[isModalOpen?.index].find(
              (ans) => ans.question_no === isModalOpen?.data.question_no
            );
        structuredData = await {
          args: {
            gsn_number: gsn_no,
            date_and_time: formatDateTime(currentDate),
            gsi_id: reg_key,
            question_id: isModalOpen?.sub_question_num,
            subquestion_id: isModalOpen?.data?.question_no,
            subquestion_previous_answer: PreviousData?.answer,
            subquestion_edited_answer: values?.[isModalOpen?.data?.question_no],
            subquestion_text: isModalOpen?.data?.question,
            question_text: isModalOpen?.subQuestion,
            section_name: "Initial Registration Details",
          },
        };
      } else {
        structuredData = await {
          args: {
            gsn_number: gsn_no,
            date_and_time: formatDateTime(currentDate),
            gsi_id: reg_key,
            question_id: isModalOpen?.data?.question_no,
            question_text: isModalOpen?.data?.question,
            previous_answer:
              isModalOpen?.type?.toLowerCase() === "section"
                ? values?.[isModalOpen?.template][isModalOpen?.index]?.[
                    isModalOpen?.data?.question_no
                  ] ||
                  (questions?.docs_answers?.length > 0 &&
                    questions?.docs_answers
                      ?.find((doc) => doc?.template === isModalOpen?.template)
                      ?.answer?.find(
                        (ele) =>
                          ele.question_no === isModalOpen?.data.question_no
                      )) ||
                  ""
                : values?.normalFields?.[isModalOpen?.data?.question_no] ||
                  (questions?.docs_answers?.length > 0 &&
                    questions?.docs_answers?.find(
                      (doc) =>
                        doc?.question_no === isModalOpen?.data?.question_no
                    )?.answer) ||
                  "",
            edited_answer: values?.[isModalOpen?.data?.question_no],
            section_name: "Initial Registration Details",
          },
        };
      }
      console.log("structuredData>>>>", structuredData);

      await editData(structuredData);
    } catch (error) {}
    //     if (isModalOpen?.type?.toLowerCase() === 'section') {
    //         const fieldPath = `${isModalOpen?.template}[${isModalOpen?.index}].${isModalOpen?.data?.question_no}`;
    //
    //         setFieldValue(fieldPath, values?.[isModalOpen?.data?.question_no]);
    //         CloseModal();
    //     } else {
    //         const fieldPath = `normalFields.${isModalOpen?.data?.question_no}`;
    //         setFieldValue(fieldPath, values?.[isModalOpen?.data?.question_no]);
    //         CloseModal();
    //     }
  };
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);

    // Extract YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits

    // Extract HH:MM:SS in 24-hour format
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const editModalSchema = Yup.object().shape({
    [isModalOpen?.data?.question_no]: (() => {
      let validation = Yup.string();

      // Check if isModalOpen?.data is defined
      if (!isModalOpen?.data) return validation;

      const fieldType = isModalOpen.data.type?.toLowerCase();
      const fieldValidation = isModalOpen.data.validation?.toLowerCase();

      // Apply validation based on `validation` property
      if (fieldValidation === "email" && !isModalOpen.data?.depend_question) {
        validation = validation.matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email address"
        );
      } else if (fieldValidation === "pan") {
        validation = validation.matches(
          /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          "Invalid PAN Number. Format: ABCDE1234F."
        );
      } else if (fieldValidation === "pincode") {
        validation = validation.matches(
          /^\d{4}$|^\d{6}$/,
          "PIN code must be exactly 4 or 6 digits"
        );
      } else if (fieldValidation === "mobile") {
        validation = validation.matches(
          /^(?:[0-9]{10}|[0-9]{7})$/,
          "Invalid contact number"
        );
      } else if (fieldValidation === "website") {
        validation = validation.url("Please enter a valid URL");
      } else if (fieldValidation === "darpan") {
        validation = validation.test(
          "is-valid-darpan",
          "Darpan ID should be in the format: XX/1234/1234567",
          (value) =>
            value?.toUpperCase() === "NA" ||
            /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
        );
      } else if (
        fieldValidation === "password" &&
        !isModalOpen.data?.depend_question
      ) {
        validation = validation.min(
          8,
          "Password must be at least 8 characters long"
        );
      } else if (fieldType === "multiselect dropdown") {
        validation = Yup.array().of(Yup.string());
      } else if (fieldType === "attach") {
        validation = Yup.object();
      }

      // Apply 'required' validation if `mandatory` is 1
      if (isModalOpen.data.mandatory === 1) {
        validation = validation.required(
          `${isModalOpen.data.question} is required`
        );
      }

      return validation;
    })(),
  });

  const modalMultiSelectedValues = (values, setModalFieldValue) => {
    const fieldPath = `normalFields.${isModalOpen?.data?.question_no}`;
    setModalFieldValue(fieldPath, values?.[isModalOpen?.data?.question_no]);
    CloseModal();
  };

  const hasAnswerForQuestion = (Fields, subQ) => {
    // Check if there are any answers in docs_answers
    const hasAnyAnswer =
      Array.isArray(questions?.docs_answers) &&
      questions?.docs_answers?.length > 0 &&
      questions?.docs_answers?.some((doc) => doc?.answer);

    // Find the specific document matching Fields.template
    const doc =
      Array.isArray(questions?.docs_answers) &&
      questions?.docs_answers?.find(
        (doc) => doc?.template === Fields?.template
      );

    // Check if there's at least one non-empty answer for the specific document
    const isAnyAnswerFilled =
      (Array.isArray(questions?.docs_answers) &&
        doc?.answer?.length > 0 &&
        doc?.answer?.some((ele) => ele.some((dt) => dt?.answer))) ||
      false;

    return isAnyAnswerFilled || hasAnyAnswer;
  };

  const { mutate: editData, isPending: editLoading } = useMutation({
    mutationFn: editRegistration,
    ...createFarmerMutationOptions,
    onMutate: async () => {
      // Cancel the current query before mutating
      await queryClient.cancelQueries(["Questions", reg_key]);
    },
    onSuccess: () => {
      // Invalidate the query to refetch the latest data
      queryClient.invalidateQueries(["Questions", reg_key]);
    },
  });

  useEffect(() => {
    if (!editLoading) {
      setIsModalOpen("");
    }
  }, [editLoading]);

  // loading questions

  // if () return;

  // set default fields

  return (
    <>
      <Formik
        initialValues={createInitialValues()}
        validationSchema={DBName !== "Raw Data DB" && modelSchema}
        enableReinitialize={true}
        onSubmit={(values) => {
          SubmitData(values);
        }}
      >
        {({
          values,
          errors,
          handleChange,
          touched,
          handleBlur,
          setFieldValue,
        }) =>
          fieldLoading || subLoading || mainRegistration ? (
            <Loading />
          ) : (
            <Form className="flex flex-col gap-[30px]" action="">
              <div className="flex flex-wrap gap-[30px] justify-between w-[100%]">
                {questions?.documents.map((Fields) => (
                  <>
                    {Fields?.paremeter && (
                      <div key={Fields.question_no} className="w-[100%]">
                        <HeaderCompo
                          className="text-2xl text-black"
                          text={Fields?.paremeter}
                          tagType="h3"
                        />
                      </div>
                    )}
                    {!notDisplayEle?.includes(Fields?.question_no) ? (
                      Fields.type.toLowerCase() === "text" ||
                      Fields.type.toLowerCase() === "number" ||
                      Fields.type.toLowerCase() === "date" ||
                      Fields.type.toLowerCase() === "password" ? (
                        <div
                          key={Fields.question_no}
                          className={`${
                            evaluateCondition(
                              values?.normalFields?.[Fields?.depend_question],
                              Fields.condition,
                              Fields.value
                            ) &&
                            Fields?.depend_question &&
                            values?.normalFields?.[Fields?.depend_question]
                              ? "block"
                              : Fields?.depend_question && Fields.condition
                              ? "hidden"
                              : "block"
                          } ${
                            Fields?.question.toLowerCase() === "comment box" ||
                            Fields?.validation === "Email"
                              ? "w-[100%]"
                              : " w-[48%]"
                          } flex gap-[10px]  `}
                        >
                          <div className="w-[100%]">
                            <CustomInput
                              disabled={
                                DBName === "Raw Data DB"
                                  ? [
                                      "IRQ-00013",
                                      "IRQ-00015",
                                      "IRQ-00017",
                                      "IRQ-00020",
                                      "IRQ-00021",
                                      "IRQ-00007",
                                      "IRQ-00008",
                                      "IRQ-00009",
                                    ].includes(Fields.question_no)
                                    ? false
                                    : true
                                  : reg_key &&
                                    questions?.docs_answers?.length > 0 &&
                                    [
                                      "IRQ-00001",
                                      "IRQ-00002",
                                      "IRQ-00003",
                                      "IRQ-00004",
                                      "IRQ-00005",
                                    ].includes(Fields.question_no)
                              }
                              required={
                                Fields?.mandatory > 0
                                  ? true
                                  : evaluateCondition(
                                      values?.normalFields?.[
                                        Fields?.depend_question
                                      ],
                                      Fields.condition,
                                      Fields.value
                                    )
                                  ? true
                                  : false
                              }
                              type={Fields.type.toLowerCase()}
                              name={`normalFields.${Fields.question_no}`}
                              label={Fields.question}
                              value={values?.normalFields?.[Fields.question_no]}
                              onChange={handleChange}
                              copy={
                                Fields?.validation === "Email" ? true : false
                              }
                            />
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                values?.normalFields?.[Fields.question_no] &&
                                errors.normalFields?.[Fields.question_no]
                              }
                            />
                            <ParagraphComp
                              className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                              text={Fields.description}
                            />
                          </div>
                          {questions?.docs_answers?.length > 0 &&
                            [
                              "IRQ-00001",
                              "IRQ-00002",
                              "IRQ-00003",
                              "IRQ-00004",
                              "IRQ-00005",
                            ].includes(Fields.question_no) &&
                            gsn_no && (
                              <div className="flex gap-[10px] mt-[8px]">
                                <div
                                  onClick={() =>
                                    OpenModal("edit", Fields, values)
                                  }
                                  className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <BorderColorIcon className="text-white" />
                                </div>
                                <div
                                  onClick={() =>
                                    OpenModal("comment", Fields, values)
                                  }
                                  className="bg-[#004878] relative h-fit rounded-full p-[8px]"
                                >
                                  {questions?.docs_answers?.length > 0 &&
                                    questions?.docs_answers?.find(
                                      (doc) =>
                                        doc?.question_no === Fields?.question_no
                                    )?.comments_for_npo && (
                                      <div className="absolute z-10 bg-[red] mt-[-15px] ml-[17px] rounded-full p-[1px] ">
                                        <NotificationsActiveIcon className=" text-[#ffffff]" />
                                      </div>
                                    )}
                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                </div>
                              </div>
                            )}
                        </div>
                      ) : Fields.type.toLowerCase() === "dropdown" ? (
                        <div
                          key={Fields.question_no}
                          className={`${
                            evaluateCondition(
                              values?.normalFields?.[Fields?.depend_question],
                              Fields.condition,
                              Fields.value
                            ) &&
                            Fields?.depend_question &&
                            values?.normalFields?.[Fields?.depend_question]
                              ? "block"
                              : Fields?.depend_question
                              ? "hidden"
                              : "block"
                          } w-[48%] flex gap-[10px] `}
                        >
                          <div className="w-[100%]">
                            <>
                              <CustomSelection
                                disabled={
                                  DBName === "Raw Data DB"
                                    ? [
                                        "IRQ-00012",
                                        "IRQ-00014",
                                        "IRQ-00016",
                                      ].includes(Fields.question_no)
                                      ? false
                                      : true
                                    : questions?.docs_answers?.length > 0 &&
                                      questions?.docs_answers?.some(
                                        (doc) => doc?.answer
                                      )
                                    ? true
                                    : false
                                }
                                required={
                                  Fields?.mandatory > 0
                                    ? true
                                    : evaluateCondition(
                                        values?.normalFields?.[
                                          Fields?.depend_question
                                        ],
                                        Fields.condition,
                                        Fields.value
                                      )
                                    ? true
                                    : false
                                }
                                options={Fields?.options}
                                value={
                                  values?.normalFields?.[Fields.question_no]
                                }
                                onChange={handleChange}
                                name={`normalFields.${Fields.question_no}`}
                                label={Fields?.question}
                              />
                              <ParagraphComp
                                className="text-[red] text-[10px] px-[8px] mt-1"
                                text={
                                  values?.normalFields?.[Fields.question_no] &&
                                  errors?.normalFields?.[Fields.question_no]
                                }
                              />
                              <ParagraphComp
                                className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                                text={Fields.description}
                              />{" "}
                            </>
                          </div>
                          {questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.some(
                              (doc) => doc?.answer
                            ) &&
                            gsn_no && (
                              <div className="flex gap-[10px] mt-[8px]">
                                <div
                                  onClick={() =>
                                    OpenModal("edit", Fields, values)
                                  }
                                  className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <BorderColorIcon className="text-white" />
                                </div>
                                <div
                                  onClick={() =>
                                    OpenModal("comment", Fields, values)
                                  }
                                  className="bg-[#004878] relative h-fit rounded-full p-[8px]"
                                >
                                  {questions?.docs_answers?.length > 0 &&
                                    questions?.docs_answers?.find(
                                      (doc) =>
                                        doc?.question_no === Fields?.question_no
                                    )?.comments_for_npo && (
                                      <div className="absolute z-10 bg-[red] mt-[-15px] ml-[17px] rounded-full p-[1px] ">
                                        <NotificationsActiveIcon className=" text-[#ffffff]" />
                                      </div>
                                    )}
                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                </div>
                              </div>
                            )}
                        </div>
                      ) : Fields?.type.toLowerCase() ===
                        "multiselect dropdown" ? (
                        <div
                          key={Fields.question_no}
                          className={` ${
                            evaluateCondition(
                              values?.normalFields?.[Fields?.depend_question],
                              Fields.condition,
                              Fields.value
                            ) &&
                            Fields?.depend_question &&
                            values?.normalFields?.[Fields?.depend_question]
                              ? "block"
                              : Fields?.depend_question
                              ? "hidden"
                              : "block"
                          } ${
                            Fields?.description?.length > 150
                              ? "w-[100%]"
                              : " w-[48%]"
                          } `}
                        >
                          <MultipleSelect
                            disabled={
                              questions?.docs_answers?.length > 0 &&
                              questions?.docs_answers?.some(
                                (doc) => doc?.answer
                              )
                            }
                            required={
                              Fields?.mandatory > 0
                                ? true
                                : evaluateCondition(
                                    values?.normalFields?.[
                                      Fields?.depend_question
                                    ],
                                    Fields.condition,
                                    Fields.value
                                  )
                                ? true
                                : false
                            }
                            options={
                              Fields?.question_no === "DRQ-00077"
                                ? Fields?.options?.filter((ele) =>
                                    values?.["normalFields"]?.[
                                      "DRQ-00076"
                                    ]?.includes(ele.value)
                                  )
                                : Fields?.options
                            }
                            maxSelect={
                              Fields.validation === "Select Upto 3" && 3
                            }
                            mappingKey={
                              Fields?.question_no !== "DRQ-00077"
                                ? "option"
                                : "option"
                            } // Pass mapping key if needed
                            // formik={formik} // Pass the formik instance
                            onValueChange={(name, values) =>
                              multiSelectedValues(
                                name,
                                Fields.question_no,
                                values,
                                setFieldValue
                              )
                            }
                            selectedValues={
                              values?.normalFields?.[Fields?.question_no] || []
                            }
                            name={`normalFields.${Fields?.question_no}`}
                            label={Fields?.question}
                          />
                        </div>
                      ) : Fields.type.toLowerCase() === "attach" ? (
                        <div
                          key={Fields.question_no}
                          className={`${
                            evaluateCondition(
                              values?.normalFields?.[Fields?.depend_question],
                              Fields.condition,
                              Fields.value
                            ) &&
                            Fields?.depend_question &&
                            values?.normalFields?.[Fields?.depend_question]
                              ? "block"
                              : Fields?.depend_question
                              ? "hidden"
                              : "block"
                          }  w-[48%] flex gap-[10px] `}
                        >
                          <div className="w-[100%]">
                            <>
                              <CustomFileInput
                                disabled={questions?.docs_answers?.some(
                                  (doc) => doc?.answer
                                )}
                                required={
                                  Fields?.mandatory > 0
                                    ? true
                                    : evaluateCondition(
                                        values?.normalFields?.[
                                          Fields?.depend_question
                                        ],
                                        Fields.condition,
                                        Fields.value
                                      )
                                    ? true
                                    : false
                                }
                                onChange={(e) => attachFile(e, setFieldValue)}
                                value={
                                  values?.["normalFields"]?.[
                                    Fields?.question_no
                                  ]?.file_name
                                }
                                name={`normalFields.${Fields.question_no}`}
                                label={Fields?.question}
                              />
                              <ParagraphComp
                                className="text-[red] text-[10px] px-[8px] mt-1"
                                text={
                                  values?.normalFields?.[Fields.question_no] &&
                                  errors.normalFields?.[Fields.question_no]
                                }
                              />
                              <ParagraphComp
                                className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                                text={Fields.description}
                              />{" "}
                            </>
                          </div>
                          {questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.some(
                              (doc) => doc?.answer
                            ) &&
                            gsn_no && (
                              <div className="flex gap-[10px] mt-[8px]">
                                <div
                                  onClick={() =>
                                    OpenModal("edit", Fields, values)
                                  }
                                  className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <BorderColorIcon className="text-white" />
                                </div>
                                <div
                                  onClick={() =>
                                    OpenModal("comment", Fields, values)
                                  }
                                  className="bg-[#004878] h-fit relative rounded-full p-[8px]"
                                >
                                  {questions?.docs_answers?.length > 0 &&
                                    questions?.docs_answers?.find(
                                      (doc) =>
                                        doc?.question_no === Fields?.question_no
                                    )?.comments_for_npo && (
                                      <div className="absolute z-10 bg-[red] mt-[-15px] ml-[17px] rounded-full p-[1px] ">
                                        <NotificationsActiveIcon className=" text-[#ffffff]" />
                                      </div>
                                    )}
                                </div>
                              </div>
                            )}
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {Fields.type.toLowerCase() === "section" ? (
                      <>
                        <div
                          key={Fields.question_no}
                          className="w-[100%]"
                          style={{ marginBottom: "40px" }}
                        >
                          <FieldArray name={Fields.template}>
                            {({ push, remove }) => (
                              <>
                                <div className="w-[100%]">
                                  <div className="p-[20px] w-[100%] border-2 rounded-t-xl flex items-start justify-between">
                                    <HeaderCompo
                                      className="text-xl text-black mt-0 m-0"
                                      tagType="h3"
                                      text="Primary Contact Numbers of the organisation"
                                    />
                                    {/* {(reg_key && DBName === "Raw Data DB") ||
                                    (!reg_key &&
                                      !DBName &&
                                      DBName !== "GSI DB") ? ( */}
                                    <div className="flex gap-[20px]">
                                      {selectedRows?.[Fields?.template]
                                        ?.length > 0 && (
                                        <m.div {...fadeIn}>
                                          <ButtonComp
                                            type="button"
                                            onClick={() =>
                                              deleteSelectedRows(
                                                remove,
                                                Fields.template
                                              )
                                            }
                                            text="Delete"
                                            className="px-[20px] h-[40px] text-[#004878] border-2 bg-transparent border-[#004878] rounded-full py-[5px]"
                                          />
                                        </m.div>
                                      )}
                                      <ButtonComp
                                        type="button"
                                        onClick={() =>
                                          push(
                                            createNewRow(Fields?.sub_questions)
                                          )
                                        } // Push an empty row
                                        text="Add"
                                        className="px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px]"
                                      />
                                    </div>
                                    {/* ) : (
                                      ""
                                    )} */}
                                  </div>
                                  <div className="overflow-x-scroll">
                                    <table className="border-2 text-[#667085] rounded-t-2xl w-[100%]">
                                      <thead>
                                        <tr className="border-b-2">
                                          <th className="p-[10px]">
                                            <div className="w-[20px]">
                                              {values?.[Fields?.template]
                                                ?.length > 0 ? (
                                                <InputCompo
                                                  // disabled={
                                                  //   questions?.docs_answers
                                                  //     ?.length > 0 &&
                                                  //   questions?.docs_answers?.some(
                                                  //     (doc) => doc?.answer
                                                  //   )
                                                  // }
                                                  type="checkbox"
                                                  className="w-[20px] h-[20px]"
                                                  checked={
                                                    selectedRows?.[
                                                      Fields?.template
                                                    ]?.length ===
                                                    values?.[Fields?.template]
                                                      ?.length
                                                  }
                                                  onChange={(e) =>
                                                    toggleAllRows(
                                                      e,
                                                      values,
                                                      Fields?.template
                                                    )
                                                  }
                                                />
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </th>
                                          <th className="p-[10px] min-w-[50px]">
                                            No.
                                          </th>
                                          {Fields.sub_questions.map((subQ) => (
                                            <th
                                              key={subQ.question_no}
                                              className="p-[10px]"
                                            >
                                              {subQ.question}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {values?.[Fields.template]?.map(
                                          (row, rowIndex) => (
                                            <tr
                                              key={rowIndex}
                                              className="border-b-2"
                                            >
                                              <td className="p-[10px]">
                                                <InputCompo
                                                  // disabled={
                                                  //   questions?.docs_answers
                                                  //     ?.length > 0 &&
                                                  //   questions?.docs_answers?.some(
                                                  //     (doc) => doc?.answer
                                                  //   )
                                                  // }
                                                  className="w-[20px] h-[20px]"
                                                  type="checkbox"
                                                  checked={selectedRows?.[
                                                    Fields?.template
                                                  ]?.includes(rowIndex)}
                                                  onChange={() =>
                                                    toggleRowSelection(
                                                      rowIndex,
                                                      Fields?.template
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td className="p-[10px]  min-w-[50px]">
                                                {rowIndex + 1}
                                              </td>
                                              {Fields?.sub_questions?.map(
                                                (subQ, subQIndex) => (
                                                  <td
                                                    key={subQ.question_no}
                                                    className="p-[10px] min-w-[400px]"
                                                  >
                                                    {subQ.type ===
                                                    "Dropdown" ? (
                                                      <div className="w-[100%]">
                                                        <div className="flex gap-[10px] w-[100%]">
                                                          <CustomSelection
                                                            className="w-[100%]"
                                                            required={
                                                              subQ?.mandatory >
                                                                0 ||
                                                              evaluateCondition(
                                                                row?.[
                                                                  subQ
                                                                    ?.depend_question
                                                                ],
                                                                subQ?.condition,
                                                                subQ?.value
                                                              )
                                                            }
                                                            imgKey="flag"
                                                            // exDataKey={subQ?.question === 'Country Code' ? 'label' : undefined}
                                                            // disabled={
                                                            //   hasAnswerForQuestion(
                                                            //     Fields,
                                                            //     subQ
                                                            //   )
                                                            //     ? true
                                                            //     : subQ?.depend_question
                                                            //     ? !evaluateCondition(
                                                            //         row?.[
                                                            //           subQ
                                                            //             ?.depend_question
                                                            //         ],
                                                            //         subQ?.condition,
                                                            //         subQ?.value
                                                            //       )
                                                            //     : false
                                                            // }
                                                            // mappingKey={subQ?.question === 'Country Code' ? 'phone' : undefined}
                                                            options={
                                                              subQ?.question ===
                                                              "Country Code"
                                                                ? allCountries.map(
                                                                    (ele) => ({
                                                                      option: `${ele.phone} - ${ele.label}`,
                                                                      flag: ele?.flag,
                                                                    })
                                                                  )
                                                                : subQ?.options
                                                            }
                                                            onChange={
                                                              handleChange
                                                            }
                                                            onBlur={handleBlur}
                                                            name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                            value={
                                                              row?.[
                                                                subQ.question_no
                                                              ]
                                                            }
                                                            label="Select"
                                                          />
                                                          {/* {hasAnswerForQuestion(
                                                            Fields,
                                                            subQ
                                                          ) &&
                                                            gsn_no && (
                                                              <div className="flex gap-[10px] mt-[8px]">
                                                                <div
                                                                  onClick={() =>
                                                                    OpenModal(
                                                                      "edit",
                                                                      subQ,
                                                                      values,
                                                                      Fields?.type,
                                                                      Fields?.template,
                                                                      rowIndex,
                                                                      Fields?.question_no,
                                                                      Fields?.question
                                                                    )
                                                                  }
                                                                  className="cursor-pointer bg-[#004878] h-fit relative rounded-full p-[8px]"
                                                                >
                                                                  <BorderColorIcon className="text-white" />
                                                                </div>
                                                                <div
                                                                  onClick={() =>
                                                                    OpenModal(
                                                                      "comment",
                                                                      Fields,
                                                                      values
                                                                    )
                                                                  }
                                                                  className="bg-[#004878] h-fit relative rounded-full p-[8px]"
                                                                >
                                                                  {Fields?.type?.toLowerCase() ===
                                                                  "section" ? (
                                                                    questions
                                                                      ?.docs_answers
                                                                      ?.length >
                                                                      0 &&
                                                                    Array.isArray(
                                                                      questions?.docs_answers?.find(
                                                                        (doc) =>
                                                                          doc?.template ===
                                                                          Fields?.template
                                                                      )?.answer
                                                                    ) &&
                                                                    questions?.docs_answers
                                                                      ?.find(
                                                                        (doc) =>
                                                                          doc?.template ===
                                                                          Fields?.template
                                                                      )
                                                                      ?.answer?.[
                                                                        rowIndex
                                                                      ]?.find(
                                                                        (doc) =>
                                                                          doc?.question_no ===
                                                                          subQ?.question_no
                                                                      )
                                                                      ?.comments_for_npo ? (
                                                                      <div className="absolute z-10 bg-[red] mt-[-20px] ml-[17px] rounded-full p-[1px]">
                                                                        <NotificationsActiveIcon className="text-[#ffffff]" />
                                                                      </div>
                                                                    ) : null
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                                </div>
                                                              </div>
                                                            )} */}
                                                        </div>

                                                        <div className="min-h-[20px]">
                                                          {errors?.[
                                                            Fields.template
                                                          ]?.[rowIndex]?.[
                                                            subQ?.question_no
                                                          ] &&
                                                            row[
                                                              subQ.question_no
                                                            ] && (
                                                              <div className="error text-[red] mt-[5px] ml-[5px]">
                                                                {
                                                                  errors?.[
                                                                    Fields
                                                                      .template
                                                                  ]?.[
                                                                    rowIndex
                                                                  ]?.[
                                                                    subQ
                                                                      .question_no
                                                                  ]
                                                                }
                                                              </div>
                                                            )}
                                                          <div className="error mt-[5px] ml-[5px]">
                                                            {!evaluateCondition(
                                                              row?.[
                                                                subQ
                                                                  ?.depend_question
                                                              ],
                                                              subQ.condition,
                                                              subQ.value
                                                            ) &&
                                                            subQ.question ===
                                                              "Area Code"
                                                              ? "Area Code is not needed for Mobile number"
                                                              : ""}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : subQ.type === "Text" ||
                                                      subQ.type === "Number" ||
                                                      subQ.type === "Date" ? (
                                                      <div className="w-[100%]">
                                                        <div className="flex gap-[10px] w-[100%]">
                                                          {console.log(
                                                            "answerss>>>>",
                                                            Array.isArray(
                                                              questions?.docs_answers
                                                            ) &&
                                                              questions?.docs_answers?.find(
                                                                (doc) =>
                                                                  doc?.template ===
                                                                  Fields?.template
                                                              )?.answer?.[
                                                                rowIndex
                                                              ]
                                                          )}
                                                          <CustomInput
                                                            required={
                                                              subQ?.mandatory >
                                                                0 ||
                                                              evaluateCondition(
                                                                row?.[
                                                                  subQ
                                                                    ?.depend_question
                                                                ],
                                                                subQ.condition,
                                                                subQ.value
                                                              )
                                                            }
                                                            // disabled={
                                                            //   hasAnswerForQuestion(
                                                            //     Fields,
                                                            //     subQ
                                                            //   )
                                                            //     ? true
                                                            //     : subQ?.depend_question
                                                            //     ? !evaluateCondition(
                                                            //         row?.[
                                                            //           subQ
                                                            //             ?.depend_question
                                                            //         ],
                                                            //         subQ.condition,
                                                            //         subQ.value
                                                            //       )
                                                            //     : questions
                                                            //         ?.docs_answers
                                                            //         ?.length >
                                                            //         0 &&
                                                            //       questions?.docs_answers
                                                            //         ?.find(
                                                            //           (doc) =>
                                                            //             doc?.template ===
                                                            //             Fields?.template
                                                            //         )
                                                            //         ?.answer?.[
                                                            //           rowIndex
                                                            //         ]?.find(
                                                            //           (ele) =>
                                                            //             ele?.question_no ===
                                                            //             subQ?.question_no
                                                            //         )
                                                            //     ? true
                                                            //     : false
                                                            // }
                                                            type={subQ?.type?.toLowerCase()}
                                                            onChange={
                                                              handleChange
                                                            }
                                                            onBlur={handleBlur}
                                                            name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                            value={
                                                              row[
                                                                subQ.question_no
                                                              ]
                                                            }
                                                            label={
                                                              subQ.question ===
                                                              "Telephone Number"
                                                                ? "Enter the number here"
                                                                : "Enter"
                                                            }
                                                          />
                                                          {/* {hasAnswerForQuestion(
                                                            Fields,
                                                            subQ
                                                          ) &&
                                                            gsn_no && (
                                                              <div className="flex gap-[10px] mt-[8px]">
                                                                <div
                                                                  onClick={() =>
                                                                    OpenModal(
                                                                      "edit",
                                                                      subQ,
                                                                      values,
                                                                      Fields?.type,
                                                                      Fields?.template,
                                                                      rowIndex
                                                                    )
                                                                  }
                                                                  className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                                >
                                                                  <BorderColorIcon className="text-white" />
                                                                </div>

                                                                <div
                                                                  onClick={() =>
                                                                    OpenModal(
                                                                      "comment",
                                                                      subQ,
                                                                      values,
                                                                      Fields?.type,
                                                                      Fields?.template,
                                                                      rowIndex,
                                                                      Fields?.question_no,
                                                                      Fields?.question
                                                                    )
                                                                  }
                                                                  className="bg-[#004878] h-fit relative rounded-full p-[8px]"
                                                                >
                                                                  {Fields?.type?.toLowerCase() ===
                                                                  "section" ? (
                                                                    questions
                                                                      ?.docs_answers
                                                                      ?.length >
                                                                      0 &&
                                                                    Array.isArray(
                                                                      questions?.docs_answers?.find(
                                                                        (doc) =>
                                                                          doc?.template ===
                                                                          Fields?.template
                                                                      )?.answer
                                                                    ) &&
                                                                    questions?.docs_answers
                                                                      ?.find(
                                                                        (doc) =>
                                                                          doc?.template ===
                                                                          Fields?.template
                                                                      )
                                                                      ?.answer?.[
                                                                        rowIndex
                                                                      ]?.find(
                                                                        (doc) =>
                                                                          doc?.question_no ===
                                                                          subQ?.question_no
                                                                      )
                                                                      ?.comments_for_npo ? (
                                                                      <div className="absolute z-10 bg-[red] mt-[-20px] ml-[17px] rounded-full p-[1px]">
                                                                        <NotificationsActiveIcon className="text-[#ffffff]" />
                                                                      </div>
                                                                    ) : null
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                                </div>
                                                              </div>
                                                            )} */}
                                                        </div>

                                                        <div className="min-h-[20px]">
                                                          {errors?.[
                                                            Fields.template
                                                          ]?.[rowIndex]?.[
                                                            subQ?.question_no
                                                          ] &&
                                                            row[
                                                              subQ.question_no
                                                            ] && (
                                                              <div className="error text-[red] mt-[5px] ml-[5px]">
                                                                {
                                                                  errors?.[
                                                                    Fields
                                                                      .template
                                                                  ]?.[
                                                                    rowIndex
                                                                  ]?.[
                                                                    subQ
                                                                      .question_no
                                                                  ]
                                                                }
                                                              </div>
                                                            )}
                                                          <div className="error mt-[5px] ml-[5px]">
                                                            {!evaluateCondition(
                                                              row?.[
                                                                subQ
                                                                  ?.depend_question
                                                              ],
                                                              subQ.condition,
                                                              subQ.value
                                                            ) &&
                                                            subQ.question ===
                                                              "Area Code"
                                                              ? "Area Code is not needed for Mobile number"
                                                              : ""}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : subQ.type.toLowerCase() ===
                                                      "attach" ? (
                                                      <div className="flex gap-[10px]">
                                                        <CustomFileInput
                                                          // disabled={
                                                          //   questions
                                                          //     ?.docs_answers
                                                          //     ?.length > 0 &&
                                                          //   questions?.docs_answers
                                                          //     ?.find(
                                                          //       (doc) =>
                                                          //         doc?.template ===
                                                          //         Fields?.template
                                                          //     )
                                                          //     ?.answer?.find(
                                                          //       (ele) =>
                                                          //         ele.question_no ===
                                                          //         subQ.question_no
                                                          //     )
                                                          // }
                                                          required={
                                                            subQ?.mandatory >
                                                              0 ||
                                                            evaluateCondition(
                                                              row?.[
                                                                subQ
                                                                  ?.depend_question
                                                              ],
                                                              subQ.condition,
                                                              subQ.value
                                                            )
                                                          }
                                                          onChange={(e) =>
                                                            attachFile(
                                                              e,
                                                              setFieldValue
                                                            )
                                                          }
                                                          name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                          value={
                                                            row[
                                                              subQ.question_no
                                                            ]?.file_name
                                                          }
                                                          label={subQ.question}
                                                        />
                                                        {/* {hasAnswerForQuestion(
                                                          Fields,
                                                          subQ
                                                        ) &&
                                                          gsn_no && (
                                                            <div className="flex gap-[10px] mt-[8px]">
                                                              <div
                                                                onClick={() =>
                                                                  OpenModal(
                                                                    "edit",
                                                                    subQ,
                                                                    values,
                                                                    Fields?.type,
                                                                    Fields?.template,
                                                                    rowIndex
                                                                  )
                                                                }
                                                                className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                              >
                                                                <BorderColorIcon className="text-white" />
                                                              </div>
                                                              <div
                                                                onClick={() =>
                                                                  OpenModal(
                                                                    "comment",
                                                                    subQ,
                                                                    values,
                                                                    Fields?.type,
                                                                    Fields?.template,
                                                                    rowIndex,
                                                                    Fields?.question_no,
                                                                    Fields?.question
                                                                  )
                                                                }
                                                                className="bg-[#004878] h-fit relative rounded-full p-[8px]"
                                                              >
                                                                {Fields?.type?.toLowerCase() ===
                                                                "section" ? (
                                                                  questions
                                                                    ?.docs_answers
                                                                    ?.length >
                                                                    0 &&
                                                                  Array.isArray(
                                                                    questions?.docs_answers?.find(
                                                                      (doc) =>
                                                                        doc?.template ===
                                                                        Fields?.template
                                                                    )?.answer
                                                                  ) &&
                                                                  questions?.docs_answers
                                                                    ?.find(
                                                                      (doc) =>
                                                                        doc?.template ===
                                                                        Fields?.template
                                                                    )
                                                                    ?.answer?.[
                                                                      rowIndex
                                                                    ]?.find(
                                                                      (doc) =>
                                                                        doc?.question_no ===
                                                                        subQ?.question_no
                                                                    )
                                                                    ?.comments_for_npo ? (
                                                                    <div className="absolute z-10 bg-[red] mt-[-20px] ml-[17px] rounded-full p-[1px]">
                                                                      <NotificationsActiveIcon className="text-[#ffffff]" />
                                                                    </div>
                                                                  ) : null
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </div>
                                                            </div>
                                                          )} */}

                                                        <div className="min-h-[20px]">
                                                          {errors?.[
                                                            Fields.template
                                                          ]?.[rowIndex][
                                                            subQ.question_no
                                                          ] &&
                                                            row[
                                                              subQ.question_no
                                                            ] && (
                                                              <div className="error text-[red] mt-[5px] ml-[5px]">
                                                                {
                                                                  errors?.[
                                                                    Fields
                                                                      .template
                                                                  ][rowIndex][
                                                                    subQ
                                                                      .question_no
                                                                  ]
                                                                }
                                                              </div>
                                                            )}
                                                        </div>
                                                      </div>
                                                    ) : subQ.type.toLowerCase() ===
                                                      "multiselect dropdown" ? (
                                                      <div>
                                                        <MultipleSelect
                                                          // disabled={
                                                          //   questions
                                                          //     ?.docs_answers
                                                          //     ?.length > 0 &&
                                                          //   questions?.docs_answers
                                                          //     ?.find(
                                                          //       (doc) =>
                                                          //         doc?.template ===
                                                          //         Fields?.template
                                                          //     )
                                                          //     ?.answer?.find(
                                                          //       (ele) =>
                                                          //         ele.question_no ===
                                                          //         subQ.question_no
                                                          //     )
                                                          // }
                                                          maxSelect={
                                                            Fields.validation ===
                                                              "Select Upto 3" &&
                                                            3
                                                          }
                                                          required={
                                                            subQ?.mandatory >
                                                              0 ||
                                                            evaluateCondition(
                                                              row?.[
                                                                subQ
                                                                  ?.depend_question
                                                              ],
                                                              subQ.condition,
                                                              subQ.value
                                                            )
                                                          }
                                                          options={
                                                            subQ?.options
                                                          }
                                                          mappingKey="option"
                                                          selectedValues={
                                                            values?.[
                                                              subQ?.question_no
                                                            ] || []
                                                          }
                                                          name={
                                                            subQ?.question_no
                                                          }
                                                          label={subQ?.question}
                                                        />

                                                        <div className="min-h-[20px]">
                                                          {errors?.[
                                                            Fields.template
                                                          ]?.[rowIndex][
                                                            subQ.question_no
                                                          ] &&
                                                            row[
                                                              subQ.question_no
                                                            ] && (
                                                              <div className="error text-[red] mt-[5px] ml-[5px]">
                                                                {
                                                                  errors?.[
                                                                    Fields
                                                                      .template
                                                                  ][rowIndex][
                                                                    subQ
                                                                      .question_no
                                                                  ]
                                                                }
                                                              </div>
                                                            )}
                                                        </div>
                                                      </div>
                                                    ) : null}
                                                  </td>
                                                )
                                              )}
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </>
                            )}
                          </FieldArray>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ))}
                <DisplayFormikValues />
              </div>
              {/* {
              (reg_key && DBName === "Raw Data DB") ||
               (!reg_key && !DBName && DBName !== "GSI DB") 
              ? ( */}
              <div className="flex justify-end">
                <ButtonComp
                  type="submit"
                  disabled={mainRegistration}
                  className={`px-[20px] py-[6px] h-[40px] text-white rounded-full ${
                    mainRegistration
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-[#004878]"
                  }`}
                  text={mainRegistration ? "Saving..." : "Save & Next"}
                />
              </div>
              {/* ) : (
                ""
              )} */}
              <ModalComp
                width={"35%"}
                modalIsOpen={isModalOpen?.["comment"]}
                closeModal={CloseModal}
              >
                <HeaderCompo
                  className="text-2xl mb-[10px] font-bold text-black mt-[10px] text-center"
                  tagType={"h3"}
                  text="Comment"
                />
                <ParagraphComp className="text-lg text-black text-center">
                  {isModalOpen?.type?.toLowerCase() === "section"
                    ? (questions?.docs_answers?.length > 0 &&
                        Array.isArray(
                          questions?.docs_answers?.find(
                            (doc) => doc?.template === isModalOpen?.template
                          )?.answer
                        ) &&
                        questions?.docs_answers
                          ?.find(
                            (doc) => doc?.template === isModalOpen?.template
                          )
                          ?.answer?.[isModalOpen?.index]?.find(
                            (doc) =>
                              doc?.question_no ===
                              isModalOpen?.data?.question_no
                          )?.comments_for_npo) ||
                      "No comment was added by the administrator"
                    : (questions?.docs_answers?.length > 0 &&
                        questions?.docs_answers?.find(
                          (doc) =>
                            doc?.question_no === isModalOpen?.data?.question_no
                        )?.comments_for_npo) ||
                      "No comment was added by the administrator."}
                </ParagraphComp>
                <div className="flex justify-end">
                  <ButtonComp
                    onClick={CloseModal}
                    type="button"
                    className=" mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]"
                  >
                    Close
                  </ButtonComp>
                </div>
              </ModalComp>
              <ModalComp
                width={"35%"}
                modalIsOpen={isModalOpen?.["edit"]}
                closeModal={CloseModal}
              >
                <Formik
                  initialValues={{
                    [isModalOpen?.data?.question_no]: "",
                  }}
                  validationSchema={editModalSchema}
                  onSubmit={(values) => {
                    updateValues(values, setFieldValue);
                  }}
                >
                  {({
                    values: modalValues,
                    errors: modalErrors,
                    handleChange,
                    setFieldValue: setModalFieldValue,
                  }) => (
                    <Form action="">
                      <div className="h-auto">
                        <div className="flex justify-end">
                          <div className="cursor-pointer" onClick={CloseModal}>
                            <CloseIcon />
                          </div>
                        </div>
                        <HeaderCompo
                          className="text-2xl mb-[10px] font-bold text-black mt-[10px] text-center"
                          tagType={"h3"}
                          text="Edit"
                        />
                        <ParagraphComp
                          className="text-lg text-black text-start"
                          text="Question"
                        />
                        <ParagraphComp
                          className="text-md mt-[10px] text-[#3f3f3f] text-start"
                          text={isModalOpen?.data?.question}
                        />
                        {(
                          isModalOpen?.type?.toLowerCase() === "section"
                            ? values?.[isModalOpen?.template][
                                isModalOpen?.index
                              ]?.[isModalOpen?.data?.question_no] ||
                              (
                                questions?.docs_answers?.length > 0 &&
                                Array.isArray(
                                  questions?.docs_answers?.find(
                                    (doc) =>
                                      doc?.template === isModalOpen?.template
                                  )?.answer
                                ) &&
                                questions?.docs_answers
                                  ?.find(
                                    (doc) =>
                                      doc?.template === isModalOpen?.template
                                  )
                                  ?.answer?.[isModalOpen?.index]?.find(
                                    (ele) =>
                                      ele?.question_no ===
                                      isModalOpen?.data.question_no
                                  )
                              )?.answer ||
                              ""
                            : values?.normalFields?.[
                                isModalOpen?.data?.question_no
                              ] ||
                              (questions?.docs_answers?.length > 0 &&
                                questions?.docs_answers?.find(
                                  (doc) =>
                                    doc?.question_no ===
                                    isModalOpen?.data?.question_no
                                )?.answer)
                        ) ? (
                          <ParagraphComp
                            className="text-lg mt-[10px] text-black text-start"
                            text="Current Answer"
                          />
                        ) : (
                          ""
                        )}
                        <ParagraphComp className="text-md mt-[10px] text-[#3f3f3f] text-start">
                          {isModalOpen?.type?.toLowerCase() === "section"
                            ? values?.[isModalOpen?.template][
                                isModalOpen?.index
                              ]?.[isModalOpen?.data?.question_no] ||
                              (questions?.docs_answers?.length > 0 &&
                                Array.isArray(
                                  questions?.docs_answers?.find(
                                    (doc) =>
                                      doc?.template === isModalOpen?.template
                                  )?.answer
                                ) &&
                                questions?.docs_answers
                                  ?.find(
                                    (doc) =>
                                      doc?.template === isModalOpen?.template
                                  )
                                  ?.answer?.find(
                                    (ele) =>
                                      ele.question_no ===
                                      isModalOpen?.data.question_no
                                  )) ||
                              ""
                            : values?.normalFields?.[
                                isModalOpen?.data?.question_no
                              ] ||
                              (questions?.docs_answers?.length > 0 &&
                                questions?.docs_answers?.find(
                                  (doc) =>
                                    doc?.question_no ===
                                    isModalOpen?.data?.question_no
                                )?.answer) ||
                              ""}
                        </ParagraphComp>
                        {isModalOpen?.data?.type.toLowerCase() === "text" ||
                        isModalOpen?.data?.type.toLowerCase() === "number" ||
                        isModalOpen?.data?.type.toLowerCase() === "date" ||
                        isModalOpen?.data?.type.toLowerCase() === "password" ? (
                          <div className="mt-[20px]">
                            <CustomInput
                              required={true}
                              type={isModalOpen?.data?.type?.toLowerCase()}
                              name={isModalOpen?.data?.question_no}
                              value={
                                modalValues?.[isModalOpen?.data?.question_no]
                              }
                              onChange={handleChange}
                              label="New Answer"
                            />
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                modalValues?.[isModalOpen?.data?.question_no] &&
                                modalErrors?.[isModalOpen?.data?.question_no]
                              }
                            />
                          </div>
                        ) : isModalOpen?.data?.type.toLowerCase() ===
                          "dropdown" ? (
                          <div className="mt-[20px]">
                            <CustomSelection
                              imgKey="flag"
                              // exDataKey={isModalOpen?.data?.question === 'Country Code' ? 'label' : undefined}
                              // mappingKey={isModalOpen?.data?.question === 'Country Code' ? 'phone' : undefined}
                              options={
                                isModalOpen?.data?.question === "Country Code"
                                  ? allCountries.map((ele) => ({
                                      option: `${ele.phone} - ${ele.label}`,
                                      flag: ele?.flag,
                                    }))
                                  : isModalOpen?.data?.options
                              }
                              required={true}
                              value={
                                modalValues?.[isModalOpen?.data.question_no]
                              }
                              onChange={handleChange}
                              name={isModalOpen?.data.question_no}
                              label="New Answer"
                            />
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                modalValues?.[isModalOpen?.data?.question_no] &&
                                modalErrors?.[isModalOpen?.data?.question_no]
                              }
                            />
                          </div>
                        ) : isModalOpen?.data?.type.toLowerCase() ===
                          "multiselect dropdown" ? (
                          <div className="mt-[20px]">
                            <MultipleSelect
                              required={true}
                              options={
                                isModalOpen?.data?.question_no === "DRQ-00077"
                                  ? isModalOpen?.data?.options?.filter((ele) =>
                                      values?.["DRQ-00076"]?.includes(ele.value)
                                    )
                                  : isModalOpen?.data?.options
                              }
                              maxSelect={
                                isModalOpen?.data.validation ===
                                  "Select Upto 3" && 3
                              }
                              mappingKey={
                                isModalOpen?.data?.question_no !== "DRQ-00077"
                                  ? "option"
                                  : "option"
                              } // Pass mapping key if needed
                              onValueChange={(values) =>
                                modalMultiSelectedValues(
                                  values,
                                  setModalFieldValue
                                )
                              }
                              selectedValues={
                                values?.[isModalOpen?.data?.question_no] || []
                              }
                              name={isModalOpen?.data?.question_no}
                              label="New Answer"
                            />
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                modalValues?.[isModalOpen?.data?.question_no] &&
                                modalErrors?.[isModalOpen?.data?.question_no]
                              }
                            />
                          </div>
                        ) : isModalOpen?.data?.type.toLowerCase() ===
                          "attach" ? (
                          <div className="mt-[20px]">
                            <CustomFileInput
                              required={true}
                              onChange={(e) =>
                                attachFile(e, setModalFieldValue)
                              }
                              value={
                                modalValues?.[isModalOpen?.data?.question_no]
                                  ?.file_name
                              }
                              name={isModalOpen?.data?.question_no}
                              label="New Answer"
                            />
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                modalValues?.[isModalOpen?.data?.question_no] &&
                                modalErrors?.[isModalOpen?.data?.question_no]
                              }
                            />
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="flex justify-center mt-[15px]">
                          <ButtonComp
                            disabled={editLoading ? true : false}
                            className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none"
                            type="Submit"
                            text={editLoading ? "Saving..." : "Save"}
                          />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </ModalComp>
            </Form>
          )
        }
      </Formik>
    </>
  );
};

export default RegistrationFirst;
